import Plyr from "plyr";
/** * Initialize video player for YouTube, Vimeo, and MP4 videos.
 * This function scans the document for elements with the class `js-player-wrapper`
 * and initializes a Plyr video player for each element based on the `data-video` attribute.
 * It supports YouTube, Vimeo, and MP4 formats.
 * * @returns {void}
 */
function initPlayer() {
  const wrappers = document.querySelectorAll(".js-player-wrapper");

  wrappers.forEach((wrapper) => {
    const url = wrapper.dataset.video;

    let element;

    if (!url) return;

    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      // YouTube
      const match = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
      const videoId = match ? match[1] : null;
      if (videoId) {
        element = document.createElement("div");
        element.className = "js-player";
        element.setAttribute("data-plyr-provider", "youtube");
        element.setAttribute("data-plyr-embed-id", videoId);
      }
    } else if (url.includes("vimeo.com")) {
      // Vimeo
      const match = url.match(/vimeo\.com\/(\d+)/);
      const videoId = match ? match[1] : null;
      if (videoId) {
        element = document.createElement("div");
        element.className = "js-player";
        element.setAttribute("data-plyr-provider", "vimeo");
        element.setAttribute("data-plyr-embed-id", videoId);
      }
    } else if (url.endsWith(".mp4")) {
      // MP4
      element = document.createElement("video");
      element.className = "js-player";
      element.setAttribute("playsinline", "");
      element.setAttribute("controls", "");

      const source = document.createElement("source");
      source.setAttribute("src", url);
      source.setAttribute("type", "video/mp4");
      element.appendChild(source);
    }

    if (element) {
      wrapper.innerHTML = "";
      wrapper.appendChild(element);
      new Plyr(element, {
        // Настрої керування можна змінити
        controls: [
          "play-large",
          "play",
          "progress",
          "mute",
          "volume",
          "airplay",
          "fullscreen",
        ],
        // ratio: "4:3",
        hideControls: true,
        youtube: { noCookie: true },
      });
    }
  });
}
export { initPlayer };

